
// src/connects/chat-message-form.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import componentId from '../helpers/component-id'
import uploadFiles from '../helpers/file-upload'
import context from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'
import { trackHandlers } from '../helpers/analytics'
import each from 'lodash/each'
import findIndex from 'lodash/findIndex'
import debounce from 'lodash/debounce'
import filter from 'lodash/filter'
import MessageStorage from '../helpers/message-storage'
import isGoogleDocUrl from '../helpers/google-doc'
import { pushRoute } from '../actions/route'
import { urlRegex } from '../helpers/url-regexp'


const UNSUBMIT_MESSAGE = 'gambaApp.unSubmitMessage'
const UrlRegex = urlRegex()

export const mapStateToProps = (state, ownProps)=> {
  const item = state.chatMessages[ownProps.chatRoom.chat_room_id] || {}
  return {
    isPosting: item.isPosting,
    isPostFailed: item.isPostFailed,
    withFiles: item.withFiles,
    uploadedFiles: state.uploadFile[ownProps.componentId],
    uploadedVideos: state.uploadVideo[ownProps.componentId],
    user: state.user.current,
    urlInfo: state.urlInfo[ownProps.componentId],
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  const onChangeEditor = (text)=> {
    return MessageStorage.getItem(UNSUBMIT_MESSAGE).then((unSubmitMessage) => {
      let messages = JSON.parse(unSubmitMessage || '[]')
      let index = findIndex(messages, (_message) => _message.id == ownProps.chatRoom.chat_room_id)
      if ( index < 0 )
        messages.push({
          type: 'chat_message',
          id: ownProps.chatRoom.chat_room_id,
          message: text,
        })
      else
        messages[index].message = text
        if (messages.length > 2)
          messages.shift()
      MessageStorage.setItem(UNSUBMIT_MESSAGE, JSON.stringify(messages))   
    }).catch(()=> undefined)
  }

  return {
    postChatMessage: (props)=> {
      props.ui.handlers && props.ui.handlers.getValue((message)=> {
        const isExistMessage = message && message.replace(/<[^>]*>/g, '').trim().length > 0;
        if (!isExistMessage) {
          return;
        }
        const attach_json = props.ui.urlLinks && JSON.stringify({ links: props.ui.urlLinks })
        dispatch(actions.postChatMessage(ownProps.chatRoom.chat_room_id, message, undefined, undefined, attach_json))
      })
    },

    postStampMessage: (code)=> {
      code && dispatch(actions.postChatMessage(
        ownProps.chatRoom.chat_room_id,
        `<div><span class="stamp ${code}"></span></div>`
      ))
    },

    onChangeMessage: onChangeEditor,
    onChangeEditor: debounce((props) => props.ui.handlers && props.ui.handlers.getValue((text)=> onChangeEditor(text)), 500),

    uploadFiles: (props, files)=> uploadFiles(files, dispatch, props.user.user_id, 'user', ownProps.componentId),

    cancelMessage: (props)=> {
      props.ui.handlers && props.ui.handlers.clearValue()
      props.updateUI({ urlLinks: undefined})
    },

    willUnmount: ()=> {
      dispatch(actions.clearUploadFilesAndVideos(ownProps.componentId))
    },

    willUpdate: (props, nextProps)=> {
      // gapiReadyがtrueになり、linkにファイル名を取得すべきGoogleドキュメントのURLが格納されている
      if (!props.ui.gapiReady && nextProps.ui.gapiReady && nextProps.ui.link) {
        dispatch(actions.fetchGoogleDriveFile(nextProps.ui.link, nextProps.componentId))
      }
      // fetchUrlInfoでリンク先情報を取得した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && !nextProps.urlInfo.isFetchFailed && nextProps.ui.handlers) {
        var urlLinks = Object.assign({}, nextProps.ui.urlLinks)
        each(nextProps.urlInfo, (v, k)=> {
          if (v && !v.isFetching && v.item && (!props.urlInfo || props.urlInfo[k] !== v.item)) {
            urlLinks[k] = v.item
          }
        })
        nextProps.updateUI({ urlLinks })
      }
      // fetcuUrlInfoでリンク先情報の取得に失敗した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && nextProps.urlInfo.isFetchFailed) {
        nextProps.updateUI({ gapiReady: false })
      }

      if (!props.ui.hasFocus && nextProps.ui.hasFocus && nextProps.urlLinks && nextProps.ui.handlers) {
        nextProps.ui.handlers.getValue((message)=> {
              // 本文中のURLでattach_jsonに含まれていないものがあれば情報を取得する
          let match
          while(match = UrlRegex.exec(message)) {
            let url = match[0]
            if ((!nextProps.urlLinks || !nextProps.urlLinks[url]) && !isGoogleDocUrl(url))
              dispatch(actions.fetchUrlInfo(url, nextProps.componentId))
          }
        })
      }
      if (props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed && (!nextProps.withFiles || (nextProps.withFiles && nextProps.ui.urlLinks))){
        nextProps.ui.handlers.clearValue()
        nextProps.updateUI({ urlLinks: undefined})
        dispatch(actions.clearUrlInfo(nextProps.componentId))
        MessageStorage.getItem(UNSUBMIT_MESSAGE).then((nextCanselMessage) => {
          let nextCanselMessages = JSON.parse(nextCanselMessage || '[]')
          let nextCanselFilter = filter(nextCanselMessages, (_nextCanselMessage) => _nextCanselMessage.id !== nextProps.chatRoom.chat_room_id)
        MessageStorage.setItem(UNSUBMIT_MESSAGE, JSON.stringify(nextCanselFilter))
        }).catch(()=> undefined)
      }  
      if (props.uploadedFiles != nextProps.uploadedFiles && !!nextProps.uploadedFiles) {
        each(nextProps.uploadedFiles, (value, key)=> {
          if (props.uploadedFiles && props.uploadedFiles[key] && props.uploadedFiles[key].isUploading &&
              value && !value.isUploading && !value.isUploadFailed) {
            dispatch(actions.postChatMessage(ownProps.chatRoom.chat_room_id, '<div></div>', [value.item.file_id], undefined, undefined))
            dispatch(actions.cancelUploadFile(ownProps.componentId, key))
          }
        })
      }
      if (props.uploadedVideos != nextProps.uploadedVideos && !!nextProps.uploadedVideos) {
        each(nextProps.uploadedVideos, (value, key)=> {
          if (props.uploadedVideos&& props.uploadedVideos[key] && props.uploadedVideos[key].isUploading &&
              value && !value.isUploading && !value.isUploadFailed) {
            dispatch(actions.postChatMessage(ownProps.chatRoom.chat_room_id, '<div></div>', undefined, [value.item.video_id], undefined))
            dispatch(actions.cancelUploadVideo(ownProps.componentId, key))
          }
        })
      }
    },
    onAddLink: (props, link)=> {
      if (isGoogleDocUrl(link)) {
        if (props.ui.gapiReady){
          dispatch(actions.fetchGoogleDriveFile(link, props.componentId))
        }
        else {
          props.updateUI({ confirmGapi: true, link })
        }
      }
      else
        dispatch(actions.fetchUrlInfo(link, props.componentId))
    },
    onDeleteLink: (props, link)=> {
      let urlLinks = Object.assign({}, props.ui.urlLinks)
      delete urlLinks[link]
      props.updateUI({ urlLinks })
    },
    showGoogleDoc:  (url)=> dispatch(actions.openRightSidePage('google_doc', { url: url }, true)),
    showGambaUrl: (url)=> {
      const paths = url.replace(/^.+groups\//, '').split('/')
      var kpi_id, diary_id, chat_room_id, match
      var group_id = parseInt(paths[0])
      if (paths.length == 2 && paths[1] == 'timeline') {
        pushRoute('group_timeline', { group_id })
      }
      else if (paths.length == 1 && paths[0] == 'home') {
        pushRoute('home_group')
      }
      else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3])
        dispatch(actions.openRightSidePage('kpi_chart', { group_id, kpi_id }))
      }
      else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1])
        dispatch(actions.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }))
      }
      else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2])
        dispatch(actions.openRightSidePage('chat_messages', { chat_room_id }))
      }
    },
    onCancelConfirmGapi: (props)=> props.updateUI({ confirmGapi: false }),
    onSuccessConfirmGapi: (props)=> props.updateUI({ confirmGapi: false, gapiReady: true }),
    hideKeyboard: (props) => props.ui.handlers && props.ui.handlers.hideKeyboard()
  }
}

export default combineHOC(
  componentId,
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: {
    handlers: undefined,
    urlLinks: undefined,
    link: undefined,
    gapiReady: ()=> window.gapi && window.gapi.client && window.gapi.client.getToken(),
    confirmGapi: false,
    hasFocus: false
  }}),
  lifecycle,
  translate(),
  trackHandlers('postChatMessage', 'post_chat_message'),
  trackHandlers('postStampMessage', 'post_chat_message'),
  context({ showStampPalette: PropTypes.func }),
)



// WEBPACK FOOTER //
// ./src/connects/chat-message-form.js